import { render, staticRenderFns } from "./header-cell.vue?vue&type=template&id=56d56720&scoped=true"
import script from "./header-cell.vue?vue&type=script&lang=ts"
export * from "./header-cell.vue?vue&type=script&lang=ts"
import style0 from "./header-cell.vue?vue&type=style&index=0&id=56d56720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d56720",
  null
  
)

export default component.exports